module.exports = __webpack_public_path__ + "img/Premium-quality1.7f6e16fc.png";